import { PostSeatmapResponse } from 'src/sdk_checkin';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib';
import { SeatmapResultModel } from './seatmap-result.state';

/** StateDetailsActions */
const ACTION_SET = '[SeatmapResult] set';
const ACTION_UPDATE = '[SeatmapResult] update';
const ACTION_RESET = '[SeatmapResult] reset';
const ACTION_FAIL = '[SeatmapResult] fail';
const ACTION_CANCEL_REQUEST = '[SeatmapResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[SeatmapResult] set from api';
const ACTION_UPDATE_FROM_API = '[SeatmapResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setSeatmapResult = createAction(ACTION_SET, props<WithRequestId<SeatmapResultModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateSeatmapResult = createAction(ACTION_UPDATE, props<WithRequestId<Partial<SeatmapResultModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetSeatmapResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelSeatmapResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failSeatmapResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setSeatmapResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<PostSeatmapResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateSeatmapResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<PostSeatmapResponse>>()
);
